let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g1BXj")).then(() => parcelRequire('2JDkO'));